import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const { reducer, actions } = createSlice({
  initialState,
  name: 'notification',
  reducers: {},
});

export { actions, reducer };
